<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
};
</script>

<template>
  <content-loader
    width="1276"
    height="243"
    viewBox="0 0 1276 243"
    :speed="2"
    primaryColor="#F9FAFF"
    secondaryColor="#D8DFF6"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <rect x="48" y="25" width="83" height="179" rx="4" />
    <rect x="149" y="60" width="83" height="144" rx="4" />
    <rect x="250" y="100" width="83" height="104" rx="4" />
    <rect x="351" y="60" width="83" height="144" rx="4" />
    <rect x="452" y="88" width="83" height="116" rx="4" />
    <rect x="553" y="39" width="83" height="165" rx="4" />
    <rect x="654" y="100" width="83" height="104" rx="4" />
    <rect x="755" y="125" width="83" height="79" rx="4" />
    <rect x="856" y="88" width="83" height="116" rx="4" />
    <rect x="957" y="48" width="83" height="156" rx="4" />
    <rect x="1058" y="76" width="83" height="128" rx="4" />
    <rect x="1159" y="60" width="83" height="144" rx="4" />
  </content-loader>
</template>
